<script setup>
import { useLayout } from '@/layout/common/composables/layout';
import { cva } from 'class-variance-authority';
import { computed } from 'vue';
const { calculatedMenuMode } = useLayout();
const props = defineProps({
    class: {
        type: String,
        default: ''
    }
});

const sidebarGroupContentVariants = cva('relative w-full flex flex-col gap-1', {
    variants: {
        variant: {
            horizontal: '!flex-row'
        }
    }
});

const sidebarGroupContentClass = computed(() => {
    return sidebarGroupContentVariants({ variant: calculatedMenuMode.value, class: props.class });
});
</script>

<template>
    <div :class="sidebarGroupContentClass">
        <slot />
    </div>
</template>
